import LinkButton from "../../../forms/Button/LinkButton";

import styles from "./styles.module.scss";

type Props = {
  title: string;
  publishDate: string;
  /** Absolute path of the article (already localized by the caller). */
  href: string;
  src: string;
};

const BlogItem = ({ title, publishDate, href, src }: Props) => {
  return (
    <div className={styles.blogItem}>
      <div className={styles.imgWrapper}>
        <img
          src={src}
          alt=""
        />
      </div>
      <div className={styles.contentWrapper}>
        <h2>{title}</h2>
        <div className={styles.infoWrapper}>
          <p className={styles.date}>{publishDate}</p>
          <span>•</span>
          <p className={styles.date}>10 min read</p>
        </div>
        <LinkButton href={href} label="Read More" />
      </div>
    </div>
  );
};

export default BlogItem;
